import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["type"],
  _excluded2 = ["recordType"];
import * as DomainsDnsService from '@wix/ambassador-domains-dns-v1-dns-zone/http';
import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { RecordType } from '../typing';
import { toASCII, toUnicode } from 'punycode';
export const DomainsDnsServiceConfig = {
  name: 'DomainsDnsApiConfig',
  baseUrl: '',
  defaultQueryConfigType: QueryConfigTypes.DYNAMIC_DATA,
  requestTransform: req => {
    if (req.domain) {
      return {
        ...req,
        domain: toASCII(req.domain)
      };
    } else if (req.domainName) {
      return {
        ...req,
        domainName: toASCII(req.domainName)
      };
    }
    return req;
  },
  responseTransform: res => {
    if (res.domain) {
      return {
        ...res,
        domain: toUnicode(res.domain)
      };
    } else if (res.domainName) {
      return {
        ...res,
        domainName: toUnicode(res.domainName)
      };
    }
    return res;
  }
};
const convertDnsRecordToDnsRecordSet = record => {
  const type = record.type,
    rest = _objectWithoutPropertiesLoose(record, _excluded);
  return {
    ...rest,
    recordType: type
  };
};
const convertDnsRecordSetToDnsRecord = record => {
  const recordType = record.recordType,
    rest = _objectWithoutPropertiesLoose(record, _excluded2);
  return {
    ...rest,
    type: recordType
  };
};
export const DomainsDnsApiConfig = {
  createDnsZone: {
    name: 'createDnsZone',
    service: DomainsDnsServiceConfig,
    isMutating: true,
    tags: ['#dns-records'],
    queryFn: async _ref => {
      let httpClient = _ref.httpClient,
        request = _ref.request;
      const createDnsZoneResponse = await httpClient.request(DomainsDnsService.createDnsZone(request));
      return createDnsZoneResponse.data;
    }
  },
  deleteDnsZone: {
    name: 'deleteDnsZone',
    service: DomainsDnsServiceConfig,
    isMutating: true,
    tags: ['#dns-records'],
    queryFn: async _ref2 => {
      let httpClient = _ref2.httpClient,
        request = _ref2.request;
      const deleteDnsZoneResponse = await httpClient.request(DomainsDnsService.deleteDnsZone(request));
      return deleteDnsZoneResponse.data;
    }
  },
  getDnsZone: {
    name: 'getDnsZone',
    service: DomainsDnsServiceConfig,
    tags: ['#dns-records'],
    queryFn: async _ref3 => {
      var _getDnsZoneResponse$d;
      let httpClient = _ref3.httpClient,
        request = _ref3.request;
      const getDnsZoneResponse = await httpClient.request(DomainsDnsService.getDnsZone({
        domainName: request.domain
      }));
      return {
        records: ((_getDnsZoneResponse$d = getDnsZoneResponse.data) == null || (_getDnsZoneResponse$d = _getDnsZoneResponse$d.dnsZone) == null || (_getDnsZoneResponse$d = _getDnsZoneResponse$d.records) == null ? void 0 : _getDnsZoneResponse$d.map(convertDnsRecordToDnsRecordSet)) ?? []
      };
    }
  },
  previewDnsZone: {
    name: 'previewDnsZone',
    service: DomainsDnsServiceConfig,
    tags: ['#dns-records'],
    queryFn: async _ref4 => {
      var _previewDnsZoneRespon, _nsRecord$values, _nsRecord$values2;
      let httpClient = _ref4.httpClient,
        request = _ref4.request;
      const previewDnsZoneResponse = await httpClient.request(DomainsDnsService.previewDnsZone({
        domainName: request.domain
      }));
      const records = ((_previewDnsZoneRespon = previewDnsZoneResponse.data) == null || (_previewDnsZoneRespon = _previewDnsZoneRespon.dnsZone) == null || (_previewDnsZoneRespon = _previewDnsZoneRespon.records) == null ? void 0 : _previewDnsZoneRespon.map(convertDnsRecordToDnsRecordSet)) ?? [];
      const nsRecord = records.find(record => record.recordType === RecordType.NS);
      return {
        ns1: nsRecord == null || (_nsRecord$values = nsRecord.values) == null ? void 0 : _nsRecord$values[0],
        ns2: nsRecord == null || (_nsRecord$values2 = nsRecord.values) == null ? void 0 : _nsRecord$values2[1],
        records
      };
    }
  },
  updateDnsZone: {
    name: 'updateDnsZone',
    service: DomainsDnsServiceConfig,
    isMutating: true,
    tags: ['#dns-records'],
    queryFn: async _ref5 => {
      var _request$additions, _request$deletions;
      let httpClient = _ref5.httpClient,
        request = _ref5.request;
      await httpClient.request(DomainsDnsService.updateDnsZone({
        domainName: request.domain,
        additions: (_request$additions = request.additions) == null ? void 0 : _request$additions.map(convertDnsRecordSetToDnsRecord),
        deletions: (_request$deletions = request.deletions) == null ? void 0 : _request$deletions.map(convertDnsRecordSetToDnsRecord)
      }));
      return {};
    }
  },
  previewDnsMainRecords: {
    name: 'previewDnsMainRecords',
    service: DomainsDnsServiceConfig,
    tags: ['#dns-records'],
    queryFn: async _ref6 => {
      var _dnsZone$records, _dnsZone$records2, _dnsZone$records3;
      let httpClient = _ref6.httpClient,
        request = _ref6.request;
      const previewDnsZoneResponse = await httpClient.request(DomainsDnsService.previewDnsZone(request));
      const dnsZone = previewDnsZoneResponse.data.dnsZone;
      const nsRecord = dnsZone == null || (_dnsZone$records = dnsZone.records) == null || (_dnsZone$records = _dnsZone$records.filter(record => record.type === RecordType.NS)) == null ? void 0 : _dnsZone$records[0];
      return {
        cname: dnsZone == null || (_dnsZone$records2 = dnsZone.records) == null || (_dnsZone$records2 = _dnsZone$records2.find(record => record.type === RecordType.CNAME)) == null || (_dnsZone$records2 = _dnsZone$records2.values) == null ? void 0 : _dnsZone$records2[0],
        aRecord: dnsZone == null || (_dnsZone$records3 = dnsZone.records) == null || (_dnsZone$records3 = _dnsZone$records3.find(record => record.type === RecordType.A)) == null || (_dnsZone$records3 = _dnsZone$records3.values) == null ? void 0 : _dnsZone$records3[0],
        nameServers: nsRecord == null ? void 0 : nsRecord.values
      };
    }
  },
  getRecordOfType: {
    name: 'getRecordOfType',
    service: DomainsDnsServiceConfig,
    tags: ['#dns-records'],
    queryFn: async _ref7 => {
      var _dnsZone$records4;
      let httpClient = _ref7.httpClient,
        request = _ref7.request;
      const getDnsZoneResponse = await httpClient.request(DomainsDnsService.getDnsZone(request));
      const dnsZone = getDnsZoneResponse.data.dnsZone;
      return {
        records: (dnsZone == null || (_dnsZone$records4 = dnsZone.records) == null ? void 0 : _dnsZone$records4.map(convertDnsRecordToDnsRecordSet).filter(record => record.recordType === request.recordType)) ?? []
      };
    }
  }
};
//# sourceMappingURL=DomainsDnsApiConfig.js.map